import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../css/navbar.css';
import AuthButton from './AuthButton';

// Pages grouped under the "Admin" dropdown (config / league-management screens).
const ADMIN_LINKS: { to: string; label: string }[] = [
  { to: '/configs', label: 'Configuration' },
  { to: '/majors', label: 'Majors' },
  { to: '/seasons', label: 'Seasons' },
  { to: '/teams', label: 'Teams' },
  { to: '/players', label: 'Players' },
  { to: '/courses', label: 'Courses' },
  { to: '/whatsapp-settings', label: 'WhatsApp' },
  { to: '/rules', label: 'Rules' },
];

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const location = useLocation();

  const toggleNavbar = () => setIsOpen((o) => !o);

  const handleLinkClick = () => {
    setIsOpen(false);
    setAdminOpen(false);
  };

  // Highlight the Admin toggle when the current page is one of its sub-pages.
  const adminActive = ADMIN_LINKS.some((l) => location.pathname.startsWith(l.to));

  return (
    <nav className="navbar">
      <button className="navbar-toggle" onClick={toggleNavbar} aria-label="Toggle navigation">
        ☰ Menu
      </button>
      <ul className={`navbar-links ${isOpen ? 'open' : ''}`}>
        <li><NavLink to="/my-career" onClick={handleLinkClick}>My Career</NavLink></li>
        <li><NavLink to="/reservations" onClick={handleLinkClick}>Reservations</NavLink></li>
        <li><NavLink to="/rounds" onClick={handleLinkClick}>Rounds</NavLink></li>
        <li><NavLink to="/standings" onClick={handleLinkClick}>Standings</NavLink></li>
        <li><NavLink to="/insights" onClick={handleLinkClick}>Insights</NavLink></li>
        <li><NavLink to="/handicaps" onClick={handleLinkClick}>Handicaps</NavLink></li>

        <li className={`navbar-dropdown ${adminOpen ? 'open' : ''}`}>
          <button
            type="button"
            className={`navbar-dropdown-toggle ${adminActive ? 'active' : ''}`}
            onClick={() => setAdminOpen((o) => !o)}
            aria-expanded={adminOpen}
            aria-haspopup="true"
          >
            Admin <span className="caret" aria-hidden>▾</span>
          </button>
          <ul className="navbar-dropdown-menu">
            {ADMIN_LINKS.map((l) => (
              <li key={l.to}><NavLink to={l.to} onClick={handleLinkClick}>{l.label}</NavLink></li>
            ))}
          </ul>
        </li>

        <li><NavLink to="/profile" onClick={handleLinkClick}>My Profile</NavLink></li>
        <li><AuthButton /></li>
      </ul>
    </nav>
  );
};

export default Navbar;
